var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TemplateTable',{attrs:{"title":_vm.$t('menu.orders-returned'),"name":"ordersReturned","url":_vm.$listRoutes.ordersReturned,"table":_vm.ordersReturned,"filters":_vm.ordersReturnedFilters,"fields":_vm.fields}})
}
var staticRenderFns = []

export { render, staticRenderFns }